import { Button, FormControl, FormErrorMessage, FormLabel, Spinner, Stack } from "@chakra-ui/react";
import { usePhoneFormSateReaction, usePhoneFormState } from "./hooks";
import { EPhoneFormState } from "../../../../store/slices/phoneFormSliceCreator";
import { PhoneNumberInput } from "../../../shared/PhoneNumberInput";

/**
 * Component for handling phone input from user
 * * Setup phone logic reactions.
 * * Encapsulate view Logic of phone form
 */
export function PhoneNumberForm() {
  const phoneForm = usePhoneFormState();
  usePhoneFormSateReaction();

  /**
   * Handles the change event for a phone input field.
   * Clearest errorMessage of the form to hide validation
   * errors while user writing.
   */
  const handleChange = (value: string): void => {
    if (phoneForm.errorMessage) {
      phoneForm.setErrorMessage("");
    }
    phoneForm.setPhone(value);
  };

  const handleSubmit = () => {
    if (phoneForm.formState === EPhoneFormState.initial) {
      phoneForm.setFormState(EPhoneFormState.validating);
    }
  };

  return (
    <Stack spacing={4}>
      <FormControl isInvalid={!!phoneForm.errorMessage}>
        <FormLabel>
          Ваш телефон
        </FormLabel>
        <PhoneNumberInput value={phoneForm.phone} onChange={handleChange} invalid={!!phoneForm.errorMessage} />
        <FormErrorMessage>{phoneForm.errorMessage}</FormErrorMessage>
      </FormControl>
      <Button isLoading={phoneForm.formState === EPhoneFormState.validating} colorScheme="brand" onClick={handleSubmit}>
        {phoneForm.formState === EPhoneFormState.initial
          ? "Продолжить"
          : <Spinner variant="white" />}
      </Button>
    </Stack>
  );
}
